import get from 'lodash/get';
import catchify from 'catchify';
import { DEAL_STAGE } from '~/constants/deal-stages';

// eslint-disable-next-line import/prefer-default-export
export async function getPdpData(context) {
  const { $axios, route, store } = context;

  const dealSlug = get(route, ['params', 'dealSlug']);

  // JIC, should already be redirected by redirect middleware
  if (!dealSlug) {
    return context.redirect('/');
  }

  const {
    avatar,
    date_joined: dateJoined,
    deals_purchased: dealsPurchased,
    email_verified: isEmailVerified,
    email,
    has_briefcase: hasBriefcase,
    has_plus: hasPlus,
    id,
    is_staff: isStaff,
    username,
  } = get(store, ['state', 'session', 'user'], {}) || {}; // user's value can be null

  // Get the query params to force render, and send them with the request
  let renderQuery = '';
  const forcePdp = get(route, ['query', 'pdp_nuxt']);
  if (['True', 'False'].includes(forcePdp)) {
    renderQuery += `?pdp_nuxt=${forcePdp}`;
  }

  // eslint-disable-next-line prefer-const
  let [err, response] = await catchify($axios({
    method: 'GET',
    url: `/api/v2/deals/${dealSlug}/details/${renderQuery}`,
    withCredentials: true,
  }));

  const deal = get(response, ['data', 'deal']);

  if (err || !deal) {
    return null;
  }

  // jl: let's set this field directly on the deal object to prevent unnecessary prop drilling
  const stageDetails = deal.stage_details;
  stageDetails.is_inactive_indefinitely = stageDetails.current_stage === DEAL_STAGE.INACTIVE
                              && stageDetails.next_stage === null;

  if (deal.banner_details) {
    // jl: prevents prop drilling to DealBannerContent
    deal.banner_details.endDate = deal.dates.end_date;
  }

  const story = get(deal, ['products', 0, 'story'], null);

  // Fetch user deal status
  // Fetch independently if user status changes before cached deal data expires
  [, response] = await catchify($axios({
    method: 'GET',
    url: `/comments/api/discussion/user_status/?deal_id=${deal.id}`,
    withCredentials: true,
  }));
  const {
    user_moderator: userMod,
    user_has_purchased: userPurchased,
    user_has_reviewed: userReviewed,
  } = (response && response.data) || {};

  // Fetch deal stats
  const [, statsResponse] = await catchify($axios({
    method: 'GET',
    url: `/api/v2/deals/${deal.id}/stats/`,
    withCredentials: true,
  }));
  const stats = (statsResponse && statsResponse.data) || {};

  return {
    deal,
    stats,
    story,
    user: {
      avatar,
      dateJoined,
      dealsPurchased,
      email,
      hasBriefcase,
      hasPlus,
      id,
      isEmailVerified,
      isStaff,
      username,
      isModerator: userMod || isStaff,
      isAuthenticated: !!id, // Might not be needed, "if user object" might be enough
      hasReviewed: userReviewed,
      hasPurchased: userPurchased,
    },
  };
}
